import React from "react";

function DownloadIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      fill="none"
      viewBox="0 0 14 14"
      className="ml-2"
    >
      <path
        stroke="#B4B4B4"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
        d="M7 2.917v8.166m0 0L11.083 7M7 11.083L2.917 7"
      ></path>
    </svg>
  );
}

export default DownloadIcon;
